import React from 'react';
import Image from 'next/legacy/image';
import { StrapiBulkResponseData } from 'apolloClient/types';

import arrowDown from '../../public/images/arrow-down.svg';

import NeighborhoodBlock from '../Neighborhood/NeighborhoodBlock';
import LineBetweenSections from 'components/LineBetweenSections';
import { NeighborhoodWithoutId } from 'apolloClient/types/Neighborhood';
import {
  getSmallImageUrlFromImage,
  getThumbnailImageUrlFromImage,
} from 'lib/getImages';
import { flattenStrapiDataItem } from 'lib/flattenStrapiBulkDataItems';
import Carousel from '../Carousel';
import { useMediaQuery, Theme } from '@mui/material';
const NearbyNeighborhoods: React.FC<{
  neighborhoods: StrapiBulkResponseData<NeighborhoodWithoutId>;
}> = ({ neighborhoods }) => {
  const lessMd = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  return (
    <>
      {neighborhoods && neighborhoods.length > 0 && (
        <>
          <LineBetweenSections hideLine={'container'} />
          <section className="container lg:pl-[50px] lg:pr-[14px] pt-3 md:pt-[36px] lg:pt-[30px]">
            <div className="flex ">
              <div className="items-center justify-center hidden w-10 mx-2 md:flex lg:w-16">
                <div className="w-10 lg:w-16 h-0.5 bg-black" />
              </div>
              <div className="justify-center text-23-29-0.77  uppercase whitespace-pre-line w-max lg:text-30-36-1 md:mx-4 font-sohneBreitBuch">
                <button className="flex items-start text-left uppercase">
                  <div className="block w-8 mr-1 md:hidden">
                    <Image src={arrowDown} alt="Nearby Neighborhoods" />
                  </div>
                  <h2 className="whitespace-pre-line">Nearby Neighborhoods</h2>
                </button>
              </div>
            </div>
            <div className="relative mb-2 md:my-4 lg:mb-14">
              <Carousel
                emblaOptions={{
                  loop: false,
                  startIndex: 0,
                  containScroll: 'trimSnaps',
                  duration: 20,
                }}
                fullWidthSlides={lessMd}
                slidesPerView={3}
              >
                {neighborhoods.slice(0, 3).map((neighbors) => (
                  <NeighborhoodBlock
                    key={`nearby-${neighbors.attributes?.slug}`}
                    href={`/${neighbors?.attributes?.slug}`}
                    imageUrl={getSmallImageUrlFromImage(
                      flattenStrapiDataItem(neighbors?.attributes?.image?.data)
                    )}
                    blurredImageUrl={getThumbnailImageUrlFromImage(
                      flattenStrapiDataItem(neighbors?.attributes?.image?.data)
                    )}
                    imageAlt={`${neighbors?.attributes?.name} photo`}
                    nameNeighbor={neighbors.attributes?.name}
                    minSalePrice={
                      neighbors?.attributes?.neighborhoodStats?.minSalePrice ||
                      0
                    }
                    maxSalePrice={
                      neighbors?.attributes?.neighborhoodStats?.maxSalePrice ||
                      0
                    }
                    description={`${
                      neighbors?.attributes?.neighborhoodStats?.saleCount || 0
                    } Condos for Sale`}
                  />
                ))}
              </Carousel>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default NearbyNeighborhoods;
